export const TEMPLATE_FREQUENCY_OPTIONS = [
  {
    text: 'Once',
    value: 'once',
  },
  {
    text: 'Weekly',
    value: 'weekly',
  },
  {
    text: 'Monthly (specific day)',
    value: 'monthly',
  },
  {
    text: 'Last business day of month',
    value: 'month_end',
  },
  {
    text: 'First business day of month',
    value: 'month_start',
  },
  {
    text: 'Quarterly',
    value: 'quarterly',
  },
  {
    text: 'Yearly',
    value: 'yearly',
  },
];
